import Vue from 'vue'
import axios from 'axios'
import AuthService from '@/service/auth/AuthService'

const _axios = axios.create({
  baseURL: `${process.env.common.fundaApi.host}`,
})

_axios.interceptors.request.use(
  config => {
    if (config.isInterceptor !== false) {
      if (
        config.headers.Authorization == null ||
        config.headers.Authorization.startsWith('Basic') === false
      ) {
        let token = localStorage.getItem(process.env.common.token.name)
        if (token != null) {
          config.headers.Authorization = `Bearer ${token}`
        }
      }
    }

    return config
  },
  error => {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  resp => {
    let data = resp.data
    if (!!data.errors) {
      let responseErr = data.errors
      if (responseErr.length > 0) {
        responseErr = data.errors[0]
        if (responseErr.extensions) {
          responseErr = responseErr.extensions
          if (!!responseErr.errors && responseErr.errors.length > 0) {
            responseErr.message = responseErr.errors[0].message
          } else {
            try {
              responseErr.message = JSON.parse(responseErr.message).message
            } catch (e) {}
          }
        }
      }
      if (responseErr.status === 401) {
        location.reload()
      }
      return Promise.reject(responseErr)
    } else if (!!resp.error) {
      Promise.reject(resp.error)
    } else {
      let r = resolveResp(resp)
      return Promise.resolve(r)
    }
  },
  error => {
    // Do something with response error
    return Promise.reject(error.response)
  }
)

function resolveResp(resp) {
  if (!!resp && Object.prototype.hasOwnProperty.call(resp, 'data')) {
    resp = resolveResp(resp.data)
  }
  return resp
}

_axios.call = async function(option) {
  if (option.data != null && option.data.isAwait === false) {
    delete option.data.isAwait
  } else {
    await AuthService.sync()
  }
  return _axios(Vue.util.extend({}, option))
}

export default _axios
